import Tracking from "../tracking/Tracking";

function logger(level: string): (...args: Array<any>) => any {
	return function () {
		const [, ...tail] = arguments;

		if (arguments.length > 0) {
			const data = {
				level: level,
				data: tail,
			};
			console[level](arguments);
			Tracking.trackError("inspiration", "login", "oidc", arguments[0], data);
		}
	};
}

type TrackingLoggerType = {
	error: (...args: Array<any>) => any;
	warn: (...args: Array<any>) => any;
	info: (...args: Array<any>) => any;
	debug: (...args: Array<any>) => any;
};
export const TrackingLogger: TrackingLoggerType = {
	error: logger("error"),
	warn: () => {},
	info: () => {},
	debug: () => {},
};
